import {
  EverProEdgePublicSolutionOrgName,
  ImproveIt360SolutionOrgName,
  InvoiceSimpleSolutionOrgName,
  JoistSolutionOrgName,
  KickservSolutionOrgName,
  MarketSharpSolutionOrgName,
  RoofsnapSolutionOrgName,
  ServiceFusionSolutionOrgName,
} from './constants';
import { isServiceNationAppDomain } from '../config/domains';
import { HOME_ROUTE, PARTNERS_ROUTE } from '../routes/namedRoutes';

const solutionOrgsWithPartnerEntryRoute = new Set<string>([
  EverProEdgePublicSolutionOrgName,
  ImproveIt360SolutionOrgName,
  InvoiceSimpleSolutionOrgName,
  JoistSolutionOrgName,
  KickservSolutionOrgName,
  MarketSharpSolutionOrgName,
  RoofsnapSolutionOrgName,
  ServiceFusionSolutionOrgName,
]);

export function getDashboardEntryRoute(solutionOrgName?: unknown) {
  if (isServiceNationAppDomain) {
    return HOME_ROUTE;
  }
  return typeof solutionOrgName === 'string' &&
    solutionOrgsWithPartnerEntryRoute.has(solutionOrgName) ?
    PARTNERS_ROUTE :
    HOME_ROUTE;
}
